import moment from 'moment';
import { product_contents } from './products';

/**
 * Ordine da mostrare nella conferma, adattato dalla response di `book`
 * (gc_checkout.php) oppure di `confirm` (gc_confirm.php): il backend le
 * restituisce con le stesse chiavi proprio perché il frontend le renderizzi
 * con un solo codice.
 *
 * La response porta `confirmcode`, `giftVoucherId`, `live_price` e l'elenco
 * `cards`, una per card emessa. Il flusso ne vende una per ordine (`qty: 1`),
 * quindi qui prendo la prima: se un giorno si venderà un carrello, è questo il
 * punto che cambia, non i componenti della conferma.
 *
 * `tsExpire` arriva in secondi unix; `giftVoucherId` e `confirmcode` sono la
 * coppia con cui gc_confirm.php rilegge l'ordine, quindi li porto avanti anche
 * se la conferma oggi non li usa per ricaricare.
 *
 * Anagrafica e azienda non stanno qui: la conferma non le mostra più, e i due
 * endpoint le porterebbero in forme diverse (dal form l'una, dal record
 * l'altra). Se un domani torneranno a servire, `giftVoucher` della response di
 * `confirm` è la sola fonte che vale su entrambe le strade.
 *
 * L'ordine porta anche taglio e marchio, cioè tutto quello che la conferma
 * mostra: è la sola cosa che sopravvive a `reset_purchase` (vedi lo store del
 * site), e la pagina non deve dipendere dalla selezione fatta in home, che a
 * ordine emesso non esiste più.
 *
 * @param {Object} response `data` della response di `book` o di `confirm`
 * @returns {Object} ordine pronto per la pagina di conferma
 */
export function build_order(response) {
  const cards = Array.isArray(response.cards) ? response.cards : [];
  const card = cards.length ? cards[0] : {};
  const contents = product_contents(card.productCode);

  return {
    id: response.giftVoucherId,
    number: response.confirmcode || '',
    code: card.discountCode || '',
    validity: card.tsExpire ? moment.unix(card.tsExpire).format('DD/MM/YYYY') : '',
    // una card appena emessa è attiva: nel record non c'è uno stato da leggere
    status: 'Attiva',
    // taglio acquistato, in euro: `live_price` è il totale dell'ordine, e il
    // flusso vende una card per ordine
    amount: Number(response.live_price) || null,
    // marchio e nome del portale su cui la card si spende: la response porta il
    // solo `productCode`, i contenuti di vetrina stanno in products.js. Il
    // ripiego su `productName` è lo stesso che fa build_products
    product: {
      ...contents,
      name: contents.name || card.productName || '',
    },
  };
}
